<template>
  <div class="content-navigation-container page-navigation-bar">
    <div class="content-navigation">
      <FriedIconButton
        :disabled="!previousPageId"
        data-external="dsr-content-navigation-previous"
        class="arrow-button"
        @click="$emit('select-page', previousPageId)"
      >
        <FriedIcon icon="arrow-left" />
      </FriedIconButton>
      <div class="page-number-container" @click="$emit('set-menu-expanded', !expanded)">
        {{ getPageName(currentPageId) }}
        <FriedIcon
          :class="[
            {
              expanded: expanded,
              collapsed: !expanded,
            },
          ]"
          icon="chevron-down"
        />
      </div>
      <FriedIconButton
        :disabled="!nextPageId"
        data-external="dsr-content-navigation-next"
        class="arrow-button"
        @click="$emit('select-page', nextPageId)"
      >
        <FriedIcon icon="arrow-right" />
      </FriedIconButton>
    </div>
    <TransitionSlideInOut v-show="expanded" :origin="SlideOrigin.Top" appear>
      <div class="menu no-padding">
        <FriedList v-if="pages.length" class="page-list">
          <li
            v-for="page of pages"
            :key="page.id"
            class="page-list-item"
            @click="
              $emit('set-menu-expanded', false);
              $emit('select-page', page.id);
            "
          >
            <BlockListItem
              :block="page.editorBlock"
              :is-current-block="currentPageId === page.id"
              :participant="participant"
              @navigate-to-section="
                $emit('set-menu-expanded', false);
                $emit('select-section', { selection: $event, pageId: page.id });
              "
            />
          </li>
        </FriedList>
      </div>
    </TransitionSlideInOut>
  </div>
</template>

<script lang="ts">
import type { PropType } from 'vue';
import { defineComponent } from 'vue';
import { useI18n } from 'vue-i18n';
import type { Page, Participant } from '@getaccept/dsr-shared-new';
import { SlideOrigin } from '@getaccept/fried-tofu';
import BlockListItem from './BlockListItem.vue';

export default defineComponent({
  components: {
    BlockListItem,
  },
  props: {
    currentPageId: {
      type: String,
      default: '',
    },
    previousPageId: {
      type: String,
      default: '',
    },
    nextPageId: {
      type: String,
      default: '',
    },
    pages: {
      type: Array as PropType<Page[]>,
      default: () => [],
    },
    participant: {
      type: Object as PropType<Participant>,
      default: null,
    },
    expanded: {
      type: Boolean,
    },
  },
  setup(props) {
    const { t } = useI18n();
    const getPageName = (pageId: string) => {
      const page = props.pages.find(({ id }) => id === pageId);
      return page?.editorBlock.content.displayName || t('untitled_page');
    };

    return {
      t,
      getPageName,
      SlideOrigin,
    };
  },
});
</script>

<style lang="scss" scoped>
@import '@getaccept/dsr-shared-new/src/scss/content-navigation';
@import '@getaccept/dsr-shared-new/src/scss/page-navigation-bar';

:deep(.button.arrow-button) {
  border-radius: 50%;
}
</style>
